import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { Layout } from "../../../../ui/layout"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import { Pagination } from "../../../../ui/organisms/pagination"
import { yearOptions } from "../../../../utils"
import { SOTFilter } from "../../../sot"
import { GetAllBusinessRegisters, resetGetAllBusinessRegistersFilters, setGetAllBusinessRegistersFiltersHeadQuarter, setGetAllBusinessRegistersFiltersItemsPerPage, setGetAllBusinessRegistersFiltersPage, setGetAllBusinessRegistersFiltersYear } from "../slice"
import { ReportRegistriAziendaliList } from "./reportList"

export function ReportRegistriAziendali() {
    const dispatch = useAppDispatch()
    const registerState = useAppSelector(state => state.register)

    useEffect(() => {
        const initialFilters = {
            ...registerState.getAllBusinessRegistersFilters,
            page: 0,
            itemsPerPage: 10
        }

        dispatch(setGetAllBusinessRegistersFiltersPage(0))
        dispatch(setGetAllBusinessRegistersFiltersItemsPerPage(10))
        dispatch(GetAllBusinessRegisters(initialFilters))
    }, [])

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_CLIENTI}
            breadcrumbItems={['Gestione Clienti', 'Report Registri Aziendali']}
            noPaddingLat
            headerLabel="Report Registri Aziendali"
        >
            <div className="p-6 flex flex-col">
                <div className="rounded-xl border border-neutral-200">
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-[minmax(220px,1fr)_minmax(220px,1fr)_auto_auto] gap-2 items-end">
                        <SOTFilter
                            value={registerState.getAllBusinessRegistersFilters.headQuarter}
                            //disabled={usersState.findMeResponse.headQuarterInfo?.code !== 'SC' && usersState.findMeResponse.role !== 'admin'}
                            onChange={(value) => dispatch(setGetAllBusinessRegistersFiltersHeadQuarter(value))}
                        />
                        <MadfarmStaticSelect
                            noOptionsMessage=""
                            key={registerState.getAllBusinessRegistersFilters.year || 'default'}
                            placeholder={'Seleziona Anno'}
                            value={registerState.getAllBusinessRegistersFilters.year?.toString()}
                            options={yearOptions}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setGetAllBusinessRegistersFiltersYear(newValue))
                            }}
                        />
                        <ButtonComponent
                            size={"lg"}
                            iconPosition={"off"}
                            variant={"outline"}
                            label="Pulisci"
                            color={"gray"}
                            onClick={() => {
                                dispatch(resetGetAllBusinessRegistersFilters())
                                dispatch(setGetAllBusinessRegistersFiltersPage(0))
                                dispatch(setGetAllBusinessRegistersFiltersItemsPerPage(10))
                                dispatch(GetAllBusinessRegisters({ page: 0, itemsPerPage: 10 }))
                            }}
                        />
                        <ButtonComponent
                            size={"lg"}
                            iconPosition={"off"}
                            variant={"outline"}
                            label="Cerca"
                            color={"orange"}
                            onClick={() => {
                                dispatch(setGetAllBusinessRegistersFiltersPage(0))
                                dispatch(setGetAllBusinessRegistersFiltersItemsPerPage(10))
                                dispatch(GetAllBusinessRegisters({
                                    ...registerState.getAllBusinessRegistersFilters,
                                    page: 0,
                                    itemsPerPage: 10
                                }))
                            }}
                        />
                    </div>
                </div>
                <Pagination
                    numbResults={registerState.getAllBusinessRegistersResponse ? registerState.getAllBusinessRegistersResponse.total : 0}
                    pages={registerState.getAllBusinessRegistersResponse?.totalPage || 1}
                    currentPage={registerState.getAllBusinessRegistersFilters.page ? registerState.getAllBusinessRegistersFilters.page : 0}
                    detailsResults={'registri'}
                    setPage={(page) => {
                        dispatch(setGetAllBusinessRegistersFiltersPage(page))
                        dispatch(GetAllBusinessRegisters({
                            ...registerState.getAllBusinessRegistersFilters,
                            page,
                            itemsPerPage: registerState.getAllBusinessRegistersFilters.itemsPerPage || 10
                        }))
                    }}
                />

                <ReportRegistriAziendaliList />
            </div>
        </Layout>
    )
}